import React from 'react'

import { EuiFlexGrid, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiImage, EuiText } from '@elastic/eui'

export interface PlannerTvLegendProps {
  colorMap: Record<string, string>
}

const categoryConfig = [
  { key: 'Major', label: 'Major Networks', logo: '/legends/Major.png', logoMarginLeft: 20 },
  { key: 'Sports', label: 'Sports', logo: '/legends/Sports.png', logoMarginLeft: 16 },
  { key: 'News', label: 'News', logo: '/legends/News.png', logoMarginLeft: 12 },
  { key: 'Entertainment', label: 'Entertainment', logo: '/legends/Entertainment.png', logoMarginLeft: 20 },
  { key: 'Family', label: 'Family Friendly', logo: '/legends/Family Friendly.png', logoMarginLeft: 18 },
  { key: 'Lifestyle', label: 'Lifestyle', logo: '/legends/Lifestyle.png', logoMarginLeft: 12 }
]

export const PlannerTvLegend: React.FC<PlannerTvLegendProps> = ({ colorMap }) => {
  const iconMarginRight = 5
  const logoWidth = 150

  return (
    <EuiFlexGrid columns={3}>
      {categoryConfig.map(item => (
        <EuiFlexItem key={item.key}>
          <EuiFlexGroup direction='column' gutterSize='xs' alignItems='flexStart'>
            <EuiFlexItem grow={false}>
              <EuiFlexGroup gutterSize='none' alignItems='center'>
                <EuiFlexItem grow={false} style={{ width: 22, marginRight: iconMarginRight }}>
                  <EuiIcon type='dot' size='l' color={colorMap[item.key]} />
                </EuiFlexItem>
                <EuiFlexItem>
                  <EuiText size='m' style={{ marginTop: 2 }}>
                    <strong>{item.label}</strong>
                  </EuiText>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
            {item.logo && (
              <EuiFlexItem grow={false} style={{ marginTop: -5 }}>
                <EuiImage alt={item.label} src={item.logo} size='m' style={{ marginLeft: item.logoMarginLeft + iconMarginRight, width: logoWidth, objectFit: 'contain' }} />
              </EuiFlexItem>
            )}
          </EuiFlexGroup>
        </EuiFlexItem>
      ))}
    </EuiFlexGrid>
  )
}

export default PlannerTvLegend
